<template>
  <div class="TestKit-commitment">
    <div class="white-page">
      <div class="flex-column" ref="content">
        <div class="commitment-title">
          <!-- <van-icon name="star" /> -->
          <span>知情同意书<br /><span>（Informed Consent Form）</span></span>
          <!-- <van-icon name="star" /> -->
        </div>
        <div class="commitment-content" v-html="html"></div>
      </div>
    </div>
    <span class="main-btn" :class="{ 'is-disabled': !isOk }">
      <van-button type="primary" @click="clickFn">
        本人已阅读并同意知情同意书
      </van-button>
    </span>
  </div>
</template>
<script>
import { Button, Icon, Toast } from 'vant'
export default {
  name: 'TestKitCommitment',
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  data() {
    return {
      ref: null,
      isOk: false,
      html: `<p>
	<p class="MsoNormal">
		<b>亲爱的参与者：</b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		我们邀请您参加天津石氏医院<b><u>结直肠肿瘤筛查和干预技术研究</u>，</b>请慎重决定是否参加本项研究。
	</p>
	<p class="2" style="margin-left:1.0cm;text-indent:-29.25pt;">
		<b>一、项目简介</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		结直肠癌是一种易防难治的肿瘤，85-90%由息肉发展为腺瘤再发展为癌症。在息肉或腺瘤阶段发现并经内镜切除息肉或腺瘤，可以预防75%的结直肠癌。在结直肠癌早期发现并进行治疗，将大大降低结直肠癌的死亡率。肠道发生息肉、腺瘤、早期肠癌时，可能会伴随粪便潜血或粪便DNA异常。本项目将使用粪便DNA检测筛选结直肠癌高危人群，检测结果阳性者将安排结肠镜检查。
	</p>
	<p class="2" style="margin-left:1.0cm;text-indent:-29.25pt;">
		<b>二、入组要求</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		工作人员会根据您的基本情况对照本研究的纳入、排除标准确定您是否符合入组的条件。
	</p>
	<p class="2" style="margin-left:1.0cm;text-indent:-29.25pt;">
		<b>三、研究步骤什么？</b><b></b>
	</p>
	<p class="MsoNormal" style="margin-left:0cm;text-indent:21.2pt;">
		<b>1. 研究单位：</b>天津石氏医院
	</p>
	<p class="MsoNormal" style="margin-left:0cm;text-indent:21.2pt;">
		<b>2. 研究步骤</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:21.25pt;">
		2.1
您将被随机地分配进入不同的检测组，粪便DNA检查组。
	</p>
	<p class="MsoNormal" style="text-indent:21.25pt;">
		2.2
入组后，工作人员会指导您填写大肠癌危险因素调查问卷，您将获得免费的粪便DNA检查，如果检测结果是阳性，您将获得一次免费的结肠镜检查。
	</p>
	<p class="2" style="margin-left:1.0cm;text-indent:-29.25pt;">
		<b>四、参加研究可能的受益</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:23.9pt;">
		您和社会将可能从本项研究中受益。此种受益包括有可能降低您的结直肠肿瘤患病风险，以及本项研究可能帮助进一步改善此疾病的筛查方法，以用于存在类似情况的其他人群。<b></b>
	</p>
	<p class="2" style="margin-left:1.0cm;text-indent:-29.25pt;">
		<b>五、参加研究可能的不良反应、风险和不适、不方便</b><b></b>
	</p>
	<p class="MsoNormal">
		&nbsp;&nbsp;&nbsp; 问卷调查和留取粪便标本：没有危险。
	</p>
	<p class="MsoNormal">
		&nbsp;&nbsp;&nbsp;&nbsp;结肠镜检查：在准备过程中可能出现水电解质紊乱，检查过程中可能出现出血、穿孔、严重的心律失常、急性心肌梗死、脑血管病、虚脱、低血糖等风险。
	</p>
	<p class="MsoNormal">
		<b>六、研究结果的使用和个人信息的保密</b><b><i></i></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		本项目研究结果可能会在医学杂志上发表，但您的个人信息将受到严格保密，除非应相关法律要求，您个人信息不会被泄露。政府管理部门、医院伦理委员会及研究人员可以按规定查阅您的资料。
	</p>
	<p class="MsoNormal">
		<b>七、关于研究费用</b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		参与本研究您将获得一次免费的粪便DNA检测，如果粪便DNA检测结果阳性，您还将获得一次免费的结肠镜检查（普通胃肠镜检查）。无痛结肠镜检查的麻醉费用、结肠镜治疗和病理检测费用、其他疾病所需的治疗和检查费用，均需个人自理。
	</p>
	<p class="MsoNormal">
		<b>八、受试者的权利和责任</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.1pt;">
		<b>1. </b><b>您的权利</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:23.5pt;">
		在参加研究的整个过程中，您都是自愿的。您可以在试验的任何阶段随时无条件退出试验。<i></i>
	</p>
	<p class="MsoNormal" style="text-indent:24.1pt;">
		<b>2. </b><b>您的责任</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		您需要提供有关自身病史和当前身体状况的真实情况，并提供有效的粪便样本。
	</p>
	<p class="MsoNormal">
		<b>九、相关联系方式</b><b></b>
	</p>
	<p class="MsoNormal" align="left" style="text-align:left;text-indent:24.0pt;">
		如果您有与本研究相关的任何问题，请通过电话<u> <span>&nbsp;&nbsp;XXXXXXXX&nbsp;&nbsp;&nbsp; </span></u>与<u>&nbsp; &nbsp;XXX&nbsp;&nbsp; </u>联系。
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		如果您有与自身权利/权益相关的任何问题，或者您想反映参与本研究过程中遭遇的困难、不满和忧虑，或者想提供与本研究有关的意见和建议，请联系天津石氏医院伦理委员会，联系电话：<u>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;XXXXXXXX&nbsp;&nbsp; </u>。
	</p>
	<p class="MsoNormal">
		<b>十、知情同意声明</b><b></b>
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		我已被告知此项研究的目的、背景、过程、风险及获益等情况。我有足够的时间和机会进行提问，问题的答复我很满意。
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		我也被告知，当我有问题、想反映困难、顾虑、对研究的建议，或想进一步获得信息，或为研究提供帮助时，应当与谁联系。
	</p>
	<p class="MsoNormal" style="text-indent:24.0pt;">
		我已经阅读这份知情同意书，并且同意参加本研究。
	</p>
</p>
<p>
	<br />
</p>`,
    }
  },
  methods: {
    setListen() {
      let ref = this.$refs.content
      this.ref = ref
      ref.addEventListener('scroll', this.listening)
    },
    listening(e) {
      let target = e.target
      if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
        this.isOk = true
      }
    },
    clickFn() {
      if (this.isOk) {
        this.$router.replace({
          path: '/TestKitInfo',
          query: { ...this.$route.query },
        })
      } else {
        Toast.fail('请阅读知情同意书')
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setListen()
    })
  },
  destroyed() {
    this.ref.removeEventListener('scroll', this.listening)
  },
}
</script>
<style lang="scss" scoped>
@import '../../style/TestKit/TestKitCommitment';
</style>